import Swiper from 'swiper';
/* eslint-disable no-inner-declarations */
const initFooterBar = () => {
  const footerBar = document.querySelector('[data-footer-bar]');
  if (!footerBar) return;

  const footerChatBtn = footerBar.querySelector('[js-hook-chat]');

  document.querySelectorAll('[data-footer-link').forEach(btn => {
    btn.addEventListener('click', e => {
      if (window.innerWidth < 1024 && btn.dataset.footerLink === 'loyalty') {
        return;
      } else {
        e.preventDefault();
        const contentToToggle = document.getElementById(e.target.dataset.id);

        document.querySelectorAll('[data-footer-content]').forEach(item => {
          if (item.id === e.target.dataset.id) {
            contentToToggle.classList.toggle('show');
          } else {
            item.classList.remove('show');
          }
        });
      }
    });
  });

  document.querySelectorAll('[data-footer-styling]').forEach(btn => {
    btn.addEventListener('click', () => {
      // If the clicked button is already the only active one, make all active
      if (
        !btn.classList.contains('inactive') &&
        document.querySelectorAll('[data-footer-styling]:not(.inactive)').length === 1
      ) {
        document.querySelectorAll('[data-footer-styling]').forEach(b => {
          b.classList.remove('inactive');
        });
      } else {
        // Otherwise, make only the clicked button active
        document.querySelectorAll('[data-footer-styling]').forEach(b => {
          if (b === btn) {
            b.classList.remove('inactive');
          } else {
            b.classList.add('inactive');
          }
        });
      }
    });
  });

  if (document.querySelector('[data-footer-content-bambuser]')) {
    const API_KEY = 'J2ecZL1q2MQ7EERTr7b3RcfZcrJdU4AZpu9uA356BHP5';
    const BASE_URL = 'https://liveshopping-api-eu.bambuser.com/v1';
    const CHANNEL_ID = document.querySelector('[data-footer-content-bambuser]').dataset.footerBambuserChannelId;

    // Add cache configuration
    const CACHE_KEY = `bambuser_shows_${CHANNEL_ID}`;
    const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    async function fetchBambuserShows() {
      try {
        // Check cache first
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
          const { data, timestamp } = JSON.parse(cachedData);
          if (Date.now() - timestamp < CACHE_DURATION) {
            return data;
          }
        }

        // If no cache or expired, fetch new data
        const response = await fetch(`${BASE_URL}/channels/${CHANNEL_ID}`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization: `Token ${API_KEY}`
          }
        });

        if (!response.ok) {
          const errorBody = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
        }

        const data = await response.json();

        // Store in cache
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            data,
            timestamp: Date.now()
          })
        );

        return data;
      } catch (error) {
        console.error('Error fetching Bambuser shows:', error);
        // On error, try to return cached data if available
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
          const { data } = JSON.parse(cachedData);
          return data;
        }
      }
    }

    fetchBambuserShows()
      .then(shows => {
        const showSlideContainer = document.querySelector('[data-bambuser-slides]');
        const showsArray = [];

        if (!shows) return;

        if (shows.playlists && Array.isArray(shows.playlists)) {
          shows.playlists.forEach(playlist => {
            if (
              (playlist.shows && Array.isArray(playlist.shows) && playlist.title === 'Coming Soon') ||
              playlist.title === 'On Demand'
            ) {
              showsArray.push(...playlist.shows);
            }
          });
        }

        function formatDate(dateString) {
          const date = new Date(dateString);
          const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ];

          const month = monthNames[date.getUTCMonth()];
          const year = date.getUTCFullYear();

          return `${month} ${year}`;
        }

        showsArray.forEach(show => {
          const productUrl =
            show.productUrl || (show.products && show.products.length > 0 ? show.products[0].url : null);

          showSlideContainer.innerHTML += `<div class="swiper-slide">
          <button class="bambuser__button" type="button" data-show="${show.id}">
            <img src="${show.preview}" width="520" alt="${show.title}">

            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 7L0 0V14L10 7Z" fill="white"/>
            </svg>


            <div>
              <p class="headiing-5 bambuser__title">${show.title}</p>
              <p>${formatDate(show.createdAt)}</p>
            </div>
          </button>
        </div>`;
        });
      })
      .then(() => {
        new Swiper('[data-bambuser-swiper]', {
          slidesPerView: 1.8,
          slidesPerGroup: 1,
          spaceBetween: 16,
          loop: true,
          breakpoints: {
            1024: {
              slidesPerView: 3.5
            },
            1280: {
              slidesPerView: 6
            }
          }
        });
      })
      .then(() => {
        if (!window.initBambuserLiveShopping) {
          window.initBambuserLiveShopping = function (item) {
            window.initBambuserLiveShopping.queue.push(item);
          };
          window.initBambuserLiveShopping.queue = [];
          const scriptNode = document.createElement('script');
          scriptNode['src'] = 'https://lcx-embed-eu.bambuser.com/default/embed.js';
          document.body.appendChild(scriptNode);
        }

        const playBtns = document.querySelectorAll('[data-show]');

        playBtns.forEach(btn => {
          window.initBambuserLiveShopping({
            showId: `${btn.dataset.show}`,
            node: btn,
            type: 'overlay'
          });

          btn.addEventListener('click', () => {
            window.initBambuserLiveShopping({
              showId: `${btn.dataset.show}`,
              node: btn,
              type: 'overlay'
            });
          });
        });
      })
      .catch(error => {
        console.error('Failed to fetch shows:', error);
      });
  }

  footerChatBtn?.addEventListener('click', () => window.Trengo.Api.Widget.open('chat'));
};

export default initFooterBar;
